import { render, staticRenderFns } from "./productQuery.vue?vue&type=template&id=18d545cf&scoped=true&"
import script from "./productQuery.vue?vue&type=script&lang=js&"
export * from "./productQuery.vue?vue&type=script&lang=js&"
import style0 from "./productQuery.vue?vue&type=style&index=0&id=18d545cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d545cf",
  null
  
)

export default component.exports